<template>
  <div id="app" @click="getTime">
    <keep-alive :include="keepAlive">
      <router-view v-if="isMenuRefersh" />
    </keep-alive>
  </div>
</template>

<script>
// import VConsole from "vconsole";
// let vConsole = new VConsole();
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      keepAlive: ["index", "images"],
      isMenuRefersh: true
    };
  },
  mounted() {},
  methods: {
    //全局刷新事件
    reload() {
      this.isMenuRefersh = false;
      this.$nextTick(function() {
        this.isMenuRefersh = true;
      });
    },
    //获取剩余时间
    getTime() {
      if (
        window.location.pathname != "/login" &&
        window.location.pathname != "/report/login" &&
        window.location.pathname != "/register"
      ) {
        if (
          localStorage.getItem("mobile_internet_writing_newsExpires") < 1800
        ) {
          refreshTokenExpiration.refreshToken();
        }
        if (localStorage.getItem("mobile_internet_writing_newsExpires") < 10) {
          this.$message.error("令牌失效，重新登录！");
          if (this.$route.query.flag == 1) {
            window.location.href = window.g.wxUrl;
          } else if (this.$route.query.flag == 3) {
            window.location.href = window.g.appUrl + "pages/login/login";
          } else if (this.$route.query.report == 1) {
            window.location.href = "/report/login";
          } else {
            window.location.href = "/login";
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-header {
  height: 1rem !important;
  background: #409eff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.36rem;
}
.nodata {
  margin-top: 0.5rem;
}
.nodata i {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue